import { createContext, useState, ReactNode } from "react";

export interface ProductContextType {
  activeProductId: string | null;
  setActiveProductId: (id: string | null) => void;
  activeNavPanel: string | null;
  setActiveNavPanel: (id: string | null) => void;
}

export const ProductContext = createContext<ProductContextType | undefined>(
  undefined
);

interface ProductProviderProps {
  children: ReactNode;
}

export function ProductProvider({ children }: ProductProviderProps) {
  const [activeProductId, setActiveProductId] = useState<string | null>(null);
  const [activeNavPanel, setActiveNavPanel] = useState<string | null>(null);

  // When product opens, close navigation
  const handleSetActiveProductId = (id: string | null) => {
    if (id !== null) {
      setActiveNavPanel(null);
    }
    setActiveProductId(id);
  };

  // When navigation opens, close product
  const handleSetActiveNavPanel = (id: string | null) => {
    if (id !== null) {
      setActiveProductId(null);
    }
    setActiveNavPanel(id);
  };

  return (
    <ProductContext.Provider
      value={{
        activeProductId,
        setActiveProductId: handleSetActiveProductId,
        activeNavPanel,
        setActiveNavPanel: handleSetActiveNavPanel,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}
